import {
  IonButtons,
  IonItem,
  IonPage,
  IonRadio,
  IonRadioGroup,
  IonContent,
  IonHeader,
  IonTitle,
  IonToolbar,
} from '@ionic/react';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { t } from 'ttag';

import BackButton from '@components/BackButton';
import { Locale, setLocale as setLocaleFn } from '@services/language-service';
import { setLocale, getLocale } from '@state/system';

export const LOCALE_TO_LABEL = () => ({
  [Locale.En]: t`English`,
  [Locale.Fr]: t`French (Canada)`,
  [Locale.De]: t`German`,
  [Locale.Pt]: t`Portuguese`,
  [Locale.Es]: t`Spanish`,
});

const Language = () => {
  const dispatch = useDispatch();
  const locale = useSelector(getLocale);

  const setLang = useCallback(
    async (value: Locale) => {
      await setLocaleFn(value);
      dispatch(setLocale(value));
    },
    [dispatch]
  );

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <BackButton />
          </IonButtons>
          <IonTitle>{t`Language`}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonRadioGroup
          data-testid="locale"
          value={locale}
          // skipcq: JS-0417
          onIonChange={(e: CustomEvent) => setLang(e.detail.value ?? '')}
        >
          {Object.keys(LOCALE_TO_LABEL()).map(key => (
            <IonItem key={key}>
              <IonRadio color="primary" value={key}>
                {LOCALE_TO_LABEL()[key as Locale]}
              </IonRadio>
            </IonItem>
          ))}
        </IonRadioGroup>
      </IonContent>
    </IonPage>
  );
};

export default Language;
